/** @format */

// 车位用途 01:产权 02:出租 03:临停
export enum UseType {
  Property = '01',
  Rent = '02',
  Stop = '03'
}

export const useTypeMap: {
  [key: string]: string;
} = {
  [UseType.Property]: '产权',
  [UseType.Rent]: '出租',
  [UseType.Stop]: '临停'
};

// 车位类别 01：产权车位 02：人防车位 03：自划车位 04：非固定车位
export enum Category {
  Property = '01',
  Defense = '02',
  Draw = '03',
  UnFixed = '04'
}

export const categoryMap: {
  [key: string]: string;
} = {
  [Category.Property]: '产权车位',
  [Category.Defense]: '人防车位',
  [Category.Draw]: '自划车位',
  [Category.UnFixed]: '非固定车位'
};

// 使用状态 01:待售 02:已售 03:待租 04:已租 05:其它
export enum UseStatus {
  WaitSale = '01',
  YetSale = '02',
  WaitRent = '03',
  YetRent = '04',
  Other = '05'
}

export const useStatusMap: {
  [key: string]: string;
} = {
  [UseStatus.WaitSale]: '待售',
  [UseStatus.YetSale]: '已售',
  [UseStatus.WaitRent]: '待租',
  [UseStatus.YetRent]: '已租',
  [UseStatus.Other]: '其它'
};

// 车位类型 01:微型车位 02:普通车位 03:子母车位
export enum SpaceType {
  Micro = '01',
  Common = '02',
  Lash = '03'
}

export const spaceTypeMap: {
  [key: string]: string;
} = {
  [SpaceType.Micro]: '微型车位',
  [SpaceType.Common]: '普通车位',
  [SpaceType.Lash]: '子母车位'
};

// 车位状态 00：停用 01：正常
export enum Status {
  Stop = '00',
  Normal = '01'
}

export const statusMap: {
  [key: string]: string;
} = {
  [Status.Stop]: '停用',
  [Status.Normal]: '正常'
};

// 操作类型 01:新增 02:出售 03:转让 04:修改 05:停用

export enum OperateType {
  Add = '01',
  // Rent = '02',
  Change = '03',
  Modify = '04',
  // Stop = '05'
  Delete = '06'
}

export const operateTypeMap: {
  [key: string]: string;
} = {
  [OperateType.Add]: '新增',
  // [OperateType.Rent] : '出售',
  [OperateType.Change]: '转让',
  [OperateType.Modify]: '修改',
  // [OperateType.Stop] : '停用'
  [OperateType.Delete]: '删除'
};

// 下发状态 // 00 下发失败，01 下发成功，02 下发中，03 无需下发

export enum SendStatus {
  Fail = '00',
  Success = '01',
  Doing = '02',
  No = '03'
}

export const sendStatusMap: {
  [key: string]: string;
} = {
  [SendStatus.Doing]: '下发中',
  [SendStatus.Success]: '下发成功',
  [SendStatus.No]: '无需下发',
  [SendStatus.Fail]: '下发失败'
};

// 套餐操作类型 01:新增 02:修改 03:删除 04:停售 05:发售 06:审核通过 07:审核不通过
export enum PackageOperateType {
  Add = '01',
  Change = '02',
  Delete = '03',
  Stop = '04',
  Sale = '05',
  Pass = '06',
  NoPass = '07',
  Nowang = '08'
}

export const packageOperateTypeMap: {
  [key: string]: string;
} = {
  [PackageOperateType.Add]: '新增',
  [PackageOperateType.Change]: '修改',
  [PackageOperateType.Delete]: '删除',
  [PackageOperateType.Stop]: '停售',
  [PackageOperateType.Sale]: '发售',
  [PackageOperateType.Pass]: '审核通过',
  [PackageOperateType.NoPass]: '审核不通过',
  [PackageOperateType.Nowang]: 'C端配置'
};

// 套餐类型 01：全天卡 02：错时卡
export enum PackageType {
  AllDay = '01',
  Mistake = '02'
}

export const packageTypeMap: {
  [key: string]: string;
} = {
  [PackageType.AllDay]: '全天卡',
  [PackageType.Mistake]: '错时卡'
};

// 车位用途 01：产权 02：长租
export enum PackageUseType {
  Property = '01',
  Rent = '02'
}

export const packageUseTypeMap: {
  [key: string]: string;
} = {
  [PackageUseType.Property]: '产权',
  [PackageUseType.Rent]: '出租'
};

export const shidaillPackageUseTypeMap: {
  [key: string]: string;
} = {
  [PackageUseType.Rent]: '出租'
};

// 套餐状态 01:待审核 02:待售 03:审核未通过 04:在售中 05:已停售
export enum PackageState {
  WaitCheck = '01',
  WaitSale = '02',
  NoCheck = '03',
  OnSale = '04',
  StopSale = '05'
}

export const packageStateMap: {
  [key: string]: string;
} = {
  [PackageState.WaitCheck]: '待审核',
  [PackageState.WaitSale]: '待售',
  [PackageState.NoCheck]: '审核未通过',
  [PackageState.OnSale]: '在售中',
  [PackageState.StopSale]: '已停售'
};

// 套餐新增是否固定车位 01：是 02：否
export enum PackageFixed {
  Yes = '01',
  No = '02'
}

export const packageFixedMap: {
  [key: string]: string;
} = {
  [PackageFixed.Yes]: '是',
  [PackageFixed.No]: '否'
};

// 套餐新增是否需后台审核 01：是 02：否
export enum PackageCVerify {
  Yes = '01',
  No = '02'
}

export const packageCVerifyMap: {
  [key: string]: string;
} = {
  [PackageCVerify.Yes]: '是',
  [PackageCVerify.No]: '否'
};

// 线上开卡是否需后台审核 01：是 02：否
export enum PackageCVerifyNew {
  Yes = '01',
  No = '02'
}

export const packageCVerifyNewMap: {
  [key: string]: string;
} = {
  [PackageCVerifyNew.Yes]: '是',
  [PackageCVerifyNew.No]: '否'
};

// C端开卡用户是否可自选车位号
export enum OptionalParkingNumber {
  Yes = '01',
  No = '02'
}

export const optionalParkingNumberMap: {
  [key: string]: string;
} = {
  [OptionalParkingNumber.Yes]: '是',
  [OptionalParkingNumber.No]: '否'
};

// 线上续费是否需后台审核 01：是 02：否
export enum PackageCVerifyRenew {
  Yes = '01',
  No = '02'
}

export const packageCVerifyRenewMap: {
  [key: string]: string;
} = {
  [PackageCVerifyRenew.Yes]: '是',
  [PackageCVerifyRenew.No]: '否'
};

// 套餐新增C端可办理业务 01：线上开卡 02：线上续费 03：线上退费
export enum PackageCType {
  Open = '01',
  Keep = '02'
  // Refund = '03',
}

export const packageCTypeMap: {
  [key: string]: string;
} = {
  [PackageCType.Open]: '线上开卡',
  [PackageCType.Keep]: '线上续费'
  // [PackageCType.Refund]: '线上退费'
};

// 套餐新增C端可办理业务 01：线上开卡 02：线上续费 03：线上退费
export enum PackagetCType {
  Keep = '02'
  // Refund = '03',
}

export const packagetCTypeMap: {
  [key: string]: string;
} = {
  [PackageCType.Keep]: '线上续费'
  // [PackageCType.Refund]: '线上退费'
};

// 套餐新增C端可办理车位数 01:车位总数-平台月卡已用车位数 02：设置独立最大数量
export enum PackageClinetNumberType {
  Used = '01',
  Set = '02'
}

export const packageClinetNumberTypeMap: {
  [key: string]: string;
} = {
  [PackageClinetNumberType.Used]: '车位总数-平台月卡已用车位数',
  [PackageClinetNumberType.Set]: '设置独立最大数量'
};

// 授权时段方式 01：每天相同 02：每天不同
export enum PackageAuthorizationType {
  Same = '01',
  Different = '02'
}

export const packageAuthorizationTypeMap: {
  [key: string]: string;
} = {
  [PackageAuthorizationType.Same]: '每天相同',
  [PackageAuthorizationType.Different]: '每天不同'
};

export const weekDescList = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'];

// 是否为地锁车位 00：否 01：是
export enum lockedType {
  Yes = '00',
  No = '01'
}

export const lockedMap: {
  [key: string]: string;
} = {
  [lockedType.Yes]: '是',
  [lockedType.No]: '否'
};
